import { request } from "#src/utils/request";
import { REFRESH_TOKEN_PATH } from "#src/utils/request/constants";

import type { AuthType, LoginInfo, UserInfoType } from "./types";

export * from "./types";

export function fetchLogin(data: LoginInfo) {
	return request
		.post("login", { json: data })
		.json<AuthType>();
}

export function fetchLogout() {
	return request.post("logout").json();
}

// Removed fetchAsyncRoutes since we're not using backend access anymore
// export function fetchAsyncRoutes() {
// 	const res = request.get("get-async-routes").json<ApiResponse<AppRouteRecordRaw[]>>();
// 	return res;
// }

export function fetchUserInfo() {
	return request.get("user-info").json<ApiResponse<UserInfoType>>();
}

export interface RefreshTokenResult {
	token: string
	refreshToken: string
}

export function fetchRefreshToken(data: { readonly refreshToken: string }) {
	return request.post(REFRESH_TOKEN_PATH, { json: data }).json<ApiResponse<RefreshTokenResult>>();
}
